import Answers from './answers';
export default Answers;
